import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { selectUiAlert } from "@/store/features/ui/selectors";
import { hideUIAlert } from "@/store/features/ui/slice";
import { AlertActions, AlertTypes } from "@/store/features/ui/types";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { Button, Modal } from "@/ui";
import { StyledAlert, StyledAlertContent, StyledAlertIcon } from "./styled";

const Alert: FC = () => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const alert = useAppSelector(selectUiAlert);

  const renderIcon = () => {
    switch (alert?.type) {
      case AlertTypes.error:
        return (
          <StyledAlertIcon>
            <img alt="error" src="/images/error.svg" />
          </StyledAlertIcon>
        );
      case AlertTypes.success:
        return (
          <StyledAlertIcon>
            <img alt="error" src="/images/success.svg" />
          </StyledAlertIcon>
        );
      default:
        return null;
    };
  };

  const onNavigateHome = () => {
    dispatch(hideUIAlert());
    const roomId = window.location.pathname.split('/room/')[1];

    navigate(`/home/${roomId}`);
  };

  const onClose = () => {
    if (alert?.url) {
      window.location.href = alert.url;
      return;
    }

    switch (alert?.action) {
      case AlertActions.navigateHome:
        onNavigateHome();
        break;
      default:
        dispatch(hideUIAlert());
        break;
    };
  };

  const onClickOk = () => {
    if (alert?.url) {
      window.location.href = alert.url;
      return;
    }

    switch (alert?.action) {
      case AlertActions.navigateHome: {
        onNavigateHome();
        return;
      }
      default:
        break;
    };

    onClose();
  };

  return (
    <Modal visible={!!alert?.visible} onClose={onClose}>
      <StyledAlert>
        {renderIcon()}
        <StyledAlertContent>
          <h3>{alert?.title}</h3>
          <p>{alert?.message}</p>
          <Button onClick={onClickOk}>OK</Button>
        </StyledAlertContent>
      </StyledAlert>
    </Modal>
  );
};

export default Alert;
